<div class="header">
    <div class="row">
        <div class="col-6">
            <h2>Modifica <strong>Cliente</strong></h2>
        </div>
        <div class="col-4" style="text-align: right; margin-top: 10px;">
            <ol class="breadcrumb">
                <li><a style="cursor: pointer;" [routerLink]="['/clienti']">Clienti</a></li>
                <li><a style="cursor: pointer;" [routerLink]="['/clienti/' + customer.IDCustomer]">Dettaglio Cliente</a></li>
                <li class="active">Modifica Cliente</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-10 portlets" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div *ngIf="customer.IDCustomer !== undefined" class="row" style="margin-top: 30px; margin-bottom: 30px;">
                    <div class="col-sm-8 offset-sm-2">
                        <form #customerForm="ngForm" role="form" class="form-horizontal form-validation">
                            <p class="section-customer-data">Dati relativi alla Società / Ditta Individuale</p>

                            <div class="form-group">
                                <label for="company-name" class="col-sm-3 control-label">Ragione Sociale
                                    Società / Ditta individuale</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="company-name"
                                           name="company-name"
                                           class="form-control"
                                           placeholder="Inserisci ragione sociale della società / ditta individuale"
                                           autocomplete="off"
                                           [(ngModel)]="customer.CompanyName">
                                    <i class="icon-drawer"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="legal-form" class="col-sm-3 control-label">Forma Giuridica</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="legal-form"
                                           name="legal-form"
                                           class="form-control"
                                           placeholder="Inserisci forma giuridica"
                                           autocomplete="off"
                                           [(ngModel)]="customer.LegalForm">
                                    <i class="icon-drawer"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="vat" class="col-sm-3 control-label">Partita IVA</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="vat"
                                           name="vat"
                                           class="form-control"
                                           placeholder="Inserisci partita IVA"
                                           autocomplete="off"
                                           [(ngModel)]="customer.VATNumber">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="fiscal-code" class="col-sm-3 control-label">Codice Fiscale</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="fiscal-code"
                                           name="fiscal-code"
                                           class="form-control"
                                           placeholder="Inserisci codice fiscale"
                                           autocomplete="off"
                                           [(ngModel)]="customer.FiscalCode">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="chamber-of-commerce" class="col-sm-3 control-label">Camera di Commercio</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="chamber-of-commerce"
                                           name="chamber-of-commerce"
                                           class="form-control"
                                           placeholder="Inserisci camera di commercio"
                                           autocomplete="off"
                                           [(ngModel)]="customer.ChamberOfCommerce">
                                    <i class="icon-drawer"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="rea-number" class="col-sm-3 control-label">Numero REA</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="rea-number"
                                           name="rea-number"
                                           class="form-control"
                                           placeholder="Inserisci numero REA (es. RM - 123456)"
                                           autocomplete="off"
                                           [(ngModel)]="customer.REANumber">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="ateco-code" class="col-sm-3 control-label">Codice ATECO</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="ateco-code"
                                           name="ateco-code"
                                           class="form-control"
                                           placeholder="Inserisci codice ATECO"
                                           autocomplete="off"
                                           [(ngModel)]="customer.AtecoCode">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="registration-date" class="col-sm-3 control-label">Data Iscrizione</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="date"
                                           id="registration-date"
                                           name="registration-date"
                                           class="form-control"
                                           autocomplete="off"
                                           [(ngModel)]="registrationDateString">
                                    <i class="icon-calendar"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="visura-date" class="col-sm-3 control-label">Data Visura</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="date"
                                           id="visura-date"
                                           name="visura-date"
                                           class="form-control"
                                           autocomplete="off"
                                           [(ngModel)]="visuraDateString">
                                    <i class="icon-calendar"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="employees" class="col-sm-3 control-label">Addetti</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="employees"
                                           name="employees"
                                           class="form-control"
                                           placeholder="Inserisci numero addetti"
                                           autocomplete="off"
                                           [(ngModel)]="customer.Employees">
                                    <i class="icon-user"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="head-office" class="col-sm-3 control-label">Sede Legale Società / Ditta
                                    Individuale (Comune e Provincia)</label>
                                <div class="col-sm-7 prepend-icon">
                                    <input type="text"
                                           id="head-office"
                                           name="head-office"
                                           class="form-control"
                                           placeholder="Inserisci comune della sede legale"
                                           autocomplete="off"
                                           [(ngModel)]="customer.HeadOffice">
                                    <i class="icon-home"></i>
                                </div>
                                <div class="col-sm-2">
                                    <input type="text"
                                           id="head-office-province"
                                           name="head-office-province"
                                           class="form-control"
                                           placeholder="Provincia"
                                           maxlength="2"
                                           autocomplete="off"
                                           [(ngModel)]="customer.HeadOfficeProvince">
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="address" class="col-sm-3 control-label">Via e Civico Sede Legale</label>
                                <div class="col-sm-7 prepend-icon">
                                    <input type="text"
                                           id="address"
                                           name="address"
                                           class="form-control"
                                           placeholder="Inserisci via della sede legale"
                                           autocomplete="off"
                                           [(ngModel)]="customer.Address">
                                    <i class="icon-home"></i>
                                </div>
                                <div class="col-sm-2">
                                    <input type="text"
                                           id="house-number"
                                           name="house-number"
                                           class="form-control"
                                           placeholder="Inserisci civico"
                                           autocomplete="off"
                                           [(ngModel)]="customer.HouseNumber">
                                </div>
                            </div>

                            <p class="section-customer-data" style="margin-top: 30px;">Banca, Fatturazione, Bilancio e Contatti</p>

                            <div class="form-group">
                                <label for="iban" class="col-sm-3 control-label">IBAN</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="iban"
                                           name="iban"
                                           class="form-control"
                                           placeholder="Inserisci IBAN (27 caratteri)"
                                           maxlength="27"
                                           autocomplete="off"
                                           (paste)="onPasteIBAN($event)"
                                           (ngModelChange)="onChangeIBAN($event)"
                                           [ngModel]="customer.IBAN">
                                    <i class="icon-credit-card"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="support-bank-name" class="col-sm-3 control-label">Nome Banca di Appoggio</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="support-bank-name"
                                           name="support-bank-name"
                                           class="form-control"
                                           placeholder="Inserisci nome banca di appoggio"
                                           autocomplete="off"
                                           [(ngModel)]="customer.SupportBankName">
                                    <i class="icon-bank"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="support-bank-bic" class="col-sm-3 control-label">BIC Banca di Appoggio</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="support-bank-bic"
                                           name="support-bank-bic"
                                           class="form-control"
                                           placeholder="Inserisci BIC banca di appoggio"
                                           autocomplete="off"
                                           [(ngModel)]="customer.SupportBankBIC">
                                    <i class="icon-bank"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="sdi-code" class="col-sm-3 control-label">Codice SDI</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="sdi-code"
                                           name="sdi-code"
                                           class="form-control"
                                           placeholder="Inserisci codice SDI"
                                           autocomplete="off"
                                           [(ngModel)]="customer.SDICode">
                                    <i class="icon-envelope"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="balance-date" class="col-sm-3 control-label">Data Bilancio</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="date"
                                           id="balance-date"
                                           name="balance-date"
                                           class="form-control"
                                           autocomplete="off"
                                           [(ngModel)]="balanceDateString">
                                    <i class="icon-calendar"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="ula-last-balance" class="col-sm-3 control-label">ULA Ultimo Bilancio</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="ula-last-balance"
                                           name="ula-last-balance"
                                           class="form-control"
                                           placeholder="Inserisci ULA ultimo bilancio"
                                           autocomplete="off"
                                           [(ngModel)]="customer.ULALastBalance">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="sales-revenues" class="col-sm-3 control-label">Ricavi Vendite e Prestazioni</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="sales-revenues"
                                           name="sales-revenues"
                                           class="form-control"
                                           placeholder="Inserisci ricavi delle vendite e delle prestazioni"
                                           autocomplete="off"
                                           [(ngModel)]="customer.SalesRevenues">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="total-assets" class="col-sm-3 control-label">Totale Attivo</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="total-assets"
                                           name="total-assets"
                                           class="form-control"
                                           placeholder="Inserisci totale attivo"
                                           autocomplete="off"
                                           [(ngModel)]="customer.TotalAssets">
                                    <i class="icon-list"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-3 control-label">Email</label>
                                <div class="col-sm-9">
                                    <app-customer-emails-editor [(emails)]="emailInputs"></app-customer-emails-editor>
                                    <div *ngIf="emailError" class="email-error">{{ emailError }}</div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="pec" class="col-sm-3 control-label">Domicilio Digitale (PEC)</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="email"
                                           id="pec"
                                           name="pec"
                                           class="form-control"
                                           placeholder="Inserisci indirizzo PEC"
                                           autocomplete="off"
                                           [(ngModel)]="customer.PEC">
                                    <i class="icon-envelope"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="phone" class="col-sm-3 control-label">Numero Telefono Fisso</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="phone"
                                           name="phone"
                                           class="form-control"
                                           placeholder="Inserisci numero di telefono fisso"
                                           autocomplete="off"
                                           [(ngModel)]="customer.Phone">
                                    <i class="icon-phone"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="mobile-phone" class="col-sm-3 control-label">Numero Telefono Cellulare</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="mobile-phone"
                                           name="mobile-phone"
                                           class="form-control"
                                           placeholder="Inserisci numero di telefono cellulare"
                                           autocomplete="off"
                                           [(ngModel)]="customer.MobilePhone">
                                    <i class="icon-phone"></i>
                                </div>
                            </div>

                            <p class="section-customer-data" style="margin-top: 30px;">Dati relativi al Legale Rappresentante</p>

                            <div class="form-group">
                                <label for="name" class="col-sm-3 control-label">Nome Legale Rappresentante</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="name"
                                           name="name"
                                           class="form-control"
                                           placeholder="Inserisci nome del legale rappresentante"
                                           autocomplete="off"
                                           [(ngModel)]="customer.Name">
                                    <i class="icon-user"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="surname" class="col-sm-3 control-label">Cognome Legale Rappresentante</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="text"
                                           id="surname"
                                           name="surname"
                                           class="form-control"
                                           placeholder="Inserisci cognome del legale rappresentante"
                                           autocomplete="off"
                                           [(ngModel)]="customer.Surname">
                                    <i class="icon-user"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="birth-place" class="col-sm-3 control-label">Luogo di Nascita Legale
                                    Rappresentante (Comune e Provincia)</label>
                                <div class="col-sm-7 prepend-icon">
                                    <input type="text"
                                           id="birth-place"
                                           name="birth-place"
                                           class="form-control"
                                           placeholder="Inserisci luogo di nascita del legale rappresentante"
                                           autocomplete="off"
                                           [(ngModel)]="customer.BirthPlace">
                                    <i class="icon-pin"></i>
                                </div>
                                <div class="col-sm-2">
                                    <input type="text"
                                           id="birth-place-province"
                                           name="birth-place-province"
                                           class="form-control"
                                           placeholder="Provincia"
                                           maxlength="2"
                                           autocomplete="off"
                                           [(ngModel)]="customer.BirthPlaceProvince">
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="birth-date" class="col-sm-3 control-label">Data di Nascita Legale
                                    Rappresentante</label>
                                <div class="col-sm-9 prepend-icon">
                                    <input type="date"
                                           id="birth-date"
                                           name="birth-date"
                                           class="form-control"
                                           autocomplete="off"
                                           [(ngModel)]="birthDateString">
                                    <i class="icon-calendar"></i>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="city" class="col-sm-3 control-label">Residenza Legale Rappresentante
                                    (Comune e Provincia)</label>
                                <div class="col-sm-7 prepend-icon">
                                    <input type="text"
                                           id="city"
                                           name="city"
                                           class="form-control"
                                           placeholder="Inserisci comune di residenza del legale rappresentante"
                                           autocomplete="off"
                                           [(ngModel)]="customer.City">
                                    <i class="icon-pin"></i>
                                </div>
                                <div class="col-sm-2">
                                    <input type="text"
                                           id="province"
                                           name="province"
                                           class="form-control"
                                           placeholder="Provincia"
                                           maxlength="2"
                                           autocomplete="off"
                                           [(ngModel)]="customer.Province">
                                </div>
                            </div>
                        </form>

                        <!-- Fuori dal form: il tema nasconde form .custom-file (opacity: 0) -->
                        <p class="section-customer-data" style="margin-top: 40px;">Documentazione</p>

                        <div class="row m-b-10" *ngFor="let documentTypeId of customerDocumentTypes">
                            <div class="col-3 m-t-12">{{ customerDocumentTypeLabels[documentTypeId] }}</div>
                            <div class="col-9 input-group mb-3">
                                <div *ngIf="allowsMultipleFiles(documentTypeId) || documentList[documentTypeId].length === 0"
                                     class="custom-file m-b-12"
                                     [class.m-t-10]="allowsMultipleFiles(documentTypeId)">
                                    <input type="file"
                                           class="custom-file-input"
                                           [id]="'customer-document-' + documentTypeId"
                                           [name]="'customer-document-' + documentTypeId"
                                           (change)="uploadDocument($event, documentTypeId)">
                                    <label class="custom-file-label"
                                           [for]="'customer-document-' + documentTypeId">{{ fileName[documentTypeId] || 'Nessun file selezionato' }}</label>
                                </div>
                                <div *ngIf="documentList[documentTypeId].length > 0" class="width-100p"
                                     [class.m-t-10]="!allowsMultipleFiles(documentTypeId)"
                                     [class.m-t-12]="allowsMultipleFiles(documentTypeId)">
                                    <ul style="list-style-type: none;">
                                        <li *ngFor="let documentDetail of documentList[documentTypeId]">
                                            <span class="label label-success"
                                                  style="font-size: 12px; margin-right: auto;">
                                                {{ documentDetail.Path }}
                                            </span>
                                            <button (click)="deleteDocument(documentDetail)"
                                                    type="button"
                                                    class="btn btn-sm btn-embossed btn-danger cursor-pointer delete-document-button">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="documentTypeId === 1" class="info-box" style="width: 100%;">
                                    <i class="fa fa-info-circle"></i>
                                    Formato accettato PDF, non ammessa la scannerizzazione del documento.
                                </div>
                                <div *ngIf="documentTypeId === 2" class="info-box" style="width: 100%;">
                                    <i class="fa fa-info-circle"></i>
                                    Formato accettato PDF/DOCX, non ammessa la scannerizzazione del documento.
                                </div>
                            </div>
                        </div>

                        <div class="row" style="margin-top: 30px;">
                            <div class="col-sm-9 offset-sm-3 text-right">
                                <a class="btn btn-embossed btn-default" style="margin-right: 10px;"
                                   [routerLink]="['/clienti/' + customer.IDCustomer]">Annulla</a>
                                <button type="button"
                                        class="btn btn-embossed btn-primary"
                                        (click)="saveAndGoToDetail()">Salva</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
